import type { Rule } from '../types';

/**
 * CSA B651 + CCQ 3.8 : largeur ≥ 1100 mm (≈ 44") requise en contexte commercial.
 * GoRampe offre toujours le 36" en commercial (choix business), mais on avertit
 * l'utilisateur. severity: 'warn' (pas 'error') — choix business confirmé.
 */
export const ruleWidthCommercial: Rule = (submission) => {
  if (submission.config.usage === 'com' && submission.config.widthIn === 36) {
    return {
      ruleId: 'width-commercial',
      severity: 'warn',
      humanMessage:
        'Largeur 36" sous le minimum commercial recommandé (44" / 1100mm). Vérifiez conformité CSA B651 / CCQ 3.8.',
    };
  }
  return null;
};
